import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  return (
    <section className="notfound-section">
      <div className="container notfound-container text-center">
        <h1 className="notfound-code">404</h1>
        <h2 className="notfound-title">Page Not Found</h2>
        <p className="notfound-desc">
          We're sorry, the page you requested could not be found.
          <br />
          Please check the URL or return to our homepage.
        </p>

        <Link to="/" className="back-home-btn" aria-label="Back to Home">
          Back to Home
        </Link>
      </div>
    </section>
  );
};

export default NotFound;